/* eslint-disable linebreak-style */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';

import GooglePlayBadge from '../../assets/images/florai/google-play-badge.png';

export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.ai.plantscare';

// Store badge pair: official Google Play badge linking to the live app,
// App Store slot disabled until the iOS release ships
export default function FloraiStoreButtons({ variant = 'light' }) {
  const isDark = variant === 'dark';
  const appStoreClass = isDark
    ? 'relative flex items-center gap-2.5 bg-[#24361B] text-[#EEF2EC] rounded-[10px] px-5 h-12 opacity-60 cursor-default select-none'
    : 'relative flex items-center gap-2.5 bg-[#EEF2EC] text-[#24361B] rounded-[10px] px-4 h-12 opacity-60 cursor-default select-none';
  const smallClass = isDark
    ? 'block text-[.62rem] text-[#A4B69A] leading-tight'
    : 'block text-[.6rem] font-semibold tracking-wider leading-tight text-[#4A5C42]';

  return (
    <div className={`flex gap-3 flex-wrap items-center ${isDark ? 'justify-center' : ''}`}>
      <a
        href={PLAY_STORE_URL}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Android app on Google Play"
        className="inline-block hover:opacity-90 transition-opacity"
      >
        <img src={GooglePlayBadge} alt="Android app on Google Play" className="h-12 w-auto block" />
      </a>
      <span className={appStoreClass} aria-disabled="true" title="iOS version coming soon">
        <svg width="22" height="22" viewBox="0 0 24 24" fill={isDark ? '#EEF2EC' : '#24361B'} aria-hidden="true">
          <path d="M17.05 12.54c-.03-2.9 2.37-4.29 2.48-4.36-1.35-1.98-3.46-2.25-4.2-2.28-1.79-.18-3.5 1.05-4.4 1.05-.91 0-2.31-1.03-3.8-1-1.95.03-3.75 1.14-4.75 2.88-2.03 3.52-.52 8.73 1.46 11.59.97 1.4 2.12 2.97 3.63 2.91 1.46-.06 2.01-.94 3.77-.94s2.26.94 3.8.91c1.57-.03 2.57-1.42 3.53-2.83 1.11-1.62 1.57-3.19 1.6-3.27-.04-.02-3.07-1.18-3.12-4.66zM14.16 4.06c.8-.97 1.34-2.32 1.19-3.66-1.15.05-2.55.77-3.38 1.74-.74.86-1.39 2.23-1.22 3.55 1.29.1 2.6-.65 3.41-1.63z" />
        </svg>
        <span className="text-left">
          <small className={smallClass}>APP STORE</small>
          <b className="text-[.95rem] leading-tight">Coming soon</b>
        </span>
      </span>
    </div>
  );
}

FloraiStoreButtons.propTypes = {
  variant: PropTypes.oneOf(['light', 'dark']),
};
